// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.btn-primary {
  color: #ffffff;
  background-color: #2db577 !important;
  border-color: #2db577 !important;
  border-radius: 30px 30px 30px 30px;
}

.btn-danger {
  color: #ffffff;
  background-color: #dc4545 !important;
  border-color: #dc4545 !important;
  border-radius: 30px 30px 30px 30px;
}

.btn-outline {
  color: black;
  border-radius: 36px;
  border: 1px solid black;
}

.btn-square {
  color: black;
  border: 1px solid black;
}

.btn-outline:hover {
  color: black;
  border-radius: 36px;
  border: 1px solid black;
}

.btn-errorpage {
  color: #ffffff;
  background-color: #0f3a5d !important;
  border-color: #0f3a5d !important;
  border-radius: 30px 30px 30px 30px;
}

.btn-errorpage:hover {
  color: #ffffff;
}

.btn-primary:disabled {
  opacity: 0.4 !important;
  cursor: not-allowed;
}

.btn-danger:disabled {
  opacity: 0.4 !important;
  cursor: not-allowed;
}

.btn-primary:disabled,
.btn-primary:hover {
  color: #ffffff;
  cursor: not-allowed;
}

.btn-microsoft {
  font-family: "Segoe UI", "Open Sans", sans-serif;
  font-weight: 600;
  color: #5e5e5e;
  background-color: #ffffff;
  border: 1px solid #8c8c8c;
  margin-right: 0px;
  padding-bottom: 1px;
  padding-top: 1px;
  text-align: center;
  justify-content: center;
  /* display: flex; */ /* removed the display:flex */
  height: 41px;
  border-radius: 0;
  box-shadow: none;
  width: 100%;
}

.bg-gradient-info {
  background: linear-gradient(87deg, #005883 0, #33dae2 100%) !important;
}

.bg-gradient-auth {
  background-image: linear-gradient(to top, #074e74, #10476c, #154064, #183a5b, #193353, #183050, #162d4c, #152a49, #11294a, #0c294b, #06284b, #00284c);
}

.navbar-vertical .navbar-nav .nav-link.active:before {
  border-left: 4px solid #43ffc5 !important;
}

.custom-warning {
  background-color: #ffc107;
  color: #000000;
}

.full-screen-container {
  display: flex;
  flex-direction: column;
  height: 100vh;
}

.custom-container {
  width: 90%;
  max-width: none !important;
}

.static-flow-viewer {
  margin-right: 23%;
}

@media (min-width: 1536px) {
  .custom-container {
    width: 80%;
    max-width: none !important;
  }
}
@media (min-width: 512px) and (max-width: 1535px) {
  .custom-container {
    width: 100%;
    max-width: none !important;
  }
}
@media (max-width: 512px) {
  .custom-container {
    width: 96%;
    max-width: none !important;
  }
}
.code_llama {
  padding: 1rem;
  font-family: inherit !important;
}

textarea {
  border-radius: 15px !important;
  font-size: large !important;
  font-family: Open Sans, sans-serif;
  resize: none;
  padding-top: 1rem !important;
  padding-left: 29px !important;
  color: #525f7f !important;
}

.info {
  background: gainsboro;
  padding: 4px 10px;
  border-radius: 15px;
  position: absolute;
  top: 1.5rem;
  margin-left: 1rem;
}

.chat-navbar {
  width: 82%;
  margin-left: 76px;
}

.less-icon {
  height: 19px;
  width: 14px;
}

@media (max-width: 768px) {
  .response-box {
    position: relative;
  }
  .static-flow-viewer {
    margin-right: 0px;
  }
  .code_llama {
    padding-left: 80px !important;
  }
  .chat-navbar {
    width: 97%;
    margin-left: 43px;
  }
  .less-icon {
    height: 29px;
    width: 15px;
  }
}
.carousel {
  margin-top: 1rem;
  max-height: 70%;
  overflow: hidden;
}

.carousel img {
  height: 100%;
  width: 100%;
  max-width: 100%;
  max-height: 100%;
}

.carousel-group {
  display: flex;
  justify-content: space-between;
}

.carousel-image-wrapper {
  flex: 1 1;
  padding: 0 5px;
}

.carousel-outer {
  position: relative;
  padding: 0 50px;
}

.carousel-dropdown {
  position: relative;
  padding: 47px;
}

.carousel-control-prev-icon {
  width: 50px;
  height: 33px;
  color: transparent;
  filter: invert(35%) sepia(0%) saturate(1000%) hue-rotate(-180deg) !important;
  margin-left: -45px;
}

.carousel-control-next-icon {
  width: 50px;
  height: 33px;
  color: transparent;
  filter: invert(35%) sepia(0%) saturate(1000%) hue-rotate(-180deg) !important;
  margin-right: -45px;
}

@media (min-width: 375px) and (max-width: 1260px) {
  .carousel-control-prev-icon {
    margin-left: -15px; /* Updated margin for smaller screens */
  }
  .carousel-control-next-icon {
    margin-right: -15px; /* Updated margin for smaller screens */
  }
}
@media (min-width: 2075px) {
  .carousel-control-prev-icon {
    margin-left: -80px; /* Updated margin for smaller screens */
  }
  .carousel-control-next-icon {
    margin-right: -80px; /* Updated margin for smaller screens */
  }
}
.questionBar {
  width: 100%;
  padding: 15px 14px;
  border: none;
  border-top: 3px dotted #cad1d7;
  background-color: transparent;
  text-align: left;
  font-size: 16px;
  color: #333;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.questionBar:hover {
  background-color: #e0e0e0; /* Slightly darker on hover for feedback */
}

.answerContent {
  display: none; /* Initially hidden */
  padding: 15px;
  border-bottom: 1px dotted #cad1d7;
}

.open .answerContent {
  display: block;
}

.questionBar::after {
  content: "";
  border: solid black;
  border-width: 0 1px 1px 0;
  display: inline-block;
  padding: 5px;
  transform: rotate(45deg);
  -webkit-transform: rotate(45deg);
  margin-left: 15px;
  transition: transform 0.3s ease;
}

.open .questionBar::after {
  transform: rotate(-135deg);
  -webkit-transform: rotate(-135deg);
}

.button-container {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  justify-content: flex-start;
}

.lighter-text {
  color: rgb(181, 174, 176);
  font-weight: lighter;
  font-size: larger;
}

.chatbot-title {
  font-weight: bolder;
  font-size: 30px;
  color: black;
}

.response-box {
  border-radius: 20px;
  border: 1px solid #cad1d7;
  background-color: #fff;
  min-height: 125px;
  overflow-y: auto;
  max-height: 800px;
}

.pre-wrap {
  white-space: pre-wrap;
  font-family: inherit;
  font-size: inherit;
  color: inherit;
}

.share-flow-modal .nav-tabs .nav-item .nav-link:hover {
  color: inherit;
  cursor: pointer;
  border-color: transparent;
}

.share-flow-modal .nav-tabs .nav-item .nav-link {
  border-bottom: 2px solid transparent;
}

.active-tab {
  border-bottom: 2px solid #15a8b8 !important;
}

.flow-embed-box {
  border: 1px;
  background-color: #fff;
  min-height: 50px;
  white-space: normal;
  overflow-wrap: break-word;
  word-wrap: break-word;
  overflow: hidden;
  padding: 10px;
}

.flow-embed-box.flow-embed-box-background-yellow {
  background-color: #fff3cd;
}

input[type=number]::-webkit-inner-spin-button,
input[type=number]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

input[type=number] {
  -moz-appearance: textfield;
}

.flow-viewer-navbar .navbar {
  padding: 0 0 8px;
}

.floating-button {
  position: fixed;
  bottom: 20px;
  right: 47px;
  z-index: 1000;
  background-color: white;
  padding: 5px 10px;
  color: black;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.2);
}

.progress-bar {
  background-color: #00284c;
}

.page-item.active .page-link {
  background-color: #00284c;
}

.custom-button-chatbot {
  border: 1px solid black;
  border-radius: 30px;
  width: 196px;
  box-sizing: border-box;
}

@-moz-document url-prefix() {
  .custom-button-chatbot {
    width: 220px;
  }
}
.selected-card-class {
  border: 2px solid #007bff;
  box-shadow: 0 0 10px rgba(0, 123, 255, 0.5);
  cursor: pointer;
}

.hover-card-class {
  border: 2px solid #17a2b8;
  box-shadow: 0 0 8px rgba(23, 162, 184, 0.5);
  cursor: pointer;
}

.price-fade-out {
  animation: fadeOut 0.3s forwards;
}

.price-fade-in {
  animation: fadeIn 0.3s forwards;
}

@keyframes fadeOut {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
    transform: scale(0.95);
  }
}
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: scale(1.05);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}
.plan-body-height {
  max-height: 33rem;
  min-height: 33rem;
}

@media (max-width: 1317px) and (min-width: 1220px) {
  .plan-body-height {
    max-height: 38rem;
    min-height: 38rem;
  }
}
@media (max-width: 1219px) and (min-width: 1120px) {
  .plan-body-height {
    max-height: 41rem;
    min-height: 41rem;
  }
}
@media (max-width: 1119px) and (min-width: 1020px) {
  .plan-body-height {
    max-height: 44rem;
    min-height: 44rem;
  }
}
@media (max-width: 1019px) and (min-width: 992px) {
  .plan-body-height {
    max-height: 47rem;
    min-height: 47rem;
  }
}
@media (max-width: 991px) and (min-width: 820px) {
  .plan-body-height {
    max-height: 39rem;
    min-height: 39rem;
  }
}
@media (max-width: 991px) and (min-width: 942px) {
  .plan-body-height {
    max-height: 39rem;
    min-height: 39rem;
  }
}
@media (max-width: 941px) and (min-width: 892px) {
  .plan-body-height {
    max-height: 41rem;
    min-height: 41rem;
  }
}
@media (max-width: 891px) and (min-width: 842px) {
  .plan-body-height {
    max-height: 44rem;
    min-height: 44rem;
  }
}
@media (max-width: 841px) and (min-width: 820px) {
  .plan-body-height {
    max-height: 46rem;
    min-height: 46rem;
  }
}
@media (max-width: 819px) and (min-width: 768px) {
  .plan-body-height {
    max-height: 49rem;
    min-height: 49rem;
  }
}
@media (max-width: 767px) {
  .plan-body-height {
    max-height: 34rem;
    min-height: 34rem;
  }
}
.plan-card-header {
  padding-right: 20px;
  padding-bottom: 8px;
}

.professional-plan-nested-cards {
  border: none;
  background-color: #f4f4f4;
  border-radius: 0px;
  margin-top: 6px;
  height: 79px;
}

.professional-card {
  padding: 0px;
  border: none;
  background-color: transparent;
}

.professional-plan-nested-cards-body {
  padding-left: 11px;
  padding-top: 0px;
}

.plan-title {
  font-size: 20px;
}

.plan-price {
  height: 3rem;
  max-height: 3rem;
  margin-top: 3px;
}

.professional-plan-nested-cards-single-icon {
  height: 25px;
  width: 80px;
  margin-top: -127px;
  margin-left: 8px;
}

@media (min-width: 990px) {
  .professional-plan-nested-cards-single-icon {
    margin-top: -109px;
    margin-left: 39px;
  }
}
.professional-plan-nested-cards-teams-icon {
  height: 31px;
  width: 80px;
  margin-left: -18px;
}

.plan-button {
  margin-top: 2px;
}

.card-nested-body {
  height: 8rem;
  max-height: 8rem;
}

.plan-main-text {
  height: 6rem;
  min-height: 6rem;
}

@media (min-width: 1127px) {
  .plan-main-text {
    height: 6rem;
    min-height: 6rem;
  }
}
@media (min-width: 992px) and (max-width: 1127px) {
  .plan-main-text {
    height: 10rem;
    min-height: 10rem;
  }
}
@media (min-width: 767px) and (max-width: 992px) {
  .plan-main-text {
    height: 8rem;
    min-height: 8rem;
  }
}
@media (min-width: 300px) and (max-width: 766px) {
  .plan-main-text {
    height: 4rem;
    min-height: 4rem;
  }
}
@media (max-width: 576px) {
  .plan-title {
    font-size: 10px;
  }
  .plan-price {
    font-size: 10px;
  }
}
@media (max-width: 767px) {
  .plan-title {
    font-size: 12px;
  }
  .plan-price {
    font-size: 12px;
  }
}
@media (max-width: 991px) {
  .plan-title {
    font-size: 15px;
  }
  .plan-price {
    font-size: 15px;
  }
}
@media (min-width: 992px) and (max-width: 1143px) {
  .plan-title {
    font-size: 12px;
  }
  .plan-price {
    font-size: 31px;
  }
}
@media (min-width: 1144px) and (max-width: 1243px) {
  .plan-title {
    font-size: 17px;
  }
  .plan-price {
    font-size: 25px;
  }
}
@media (min-width: 1244px) {
  .plan-title {
    font-size: 18px;
  }
  .plan-price {
    font-size: 31px;
  }
}
.translatin-icon {
  height: 120px;
  width: 120px;
}

.list-item-spacing {
  margin-bottom: 3px;
}

.plan-card-details {
  background-color: #fdfdfd;
  padding: 10px;
  margin-left: -18px;
  width: 120%;
  margin-bottom: 10px;
}

.icon-container {
  flex-shrink: 0; /* Ensures the icon container does not shrink */
  margin-right: 8px; /* Adjust the margin as needed */
}

.text-container {
  flex-grow: 1; /* Allows the text container to grow and take up the remaining space */
}

@media (max-width: 767px) {
  .plan-card-details {
    width: 100%;
  }
}
.btn-primary-dashboard {
  color: #2db677;
  background-color: transparent;
  border-color: #2db677 !important;
  border-radius: 30px 30px 30px 30px;
}

.btn-primary-dashboard:hover {
  color: #2db677;
  background-color: transparent;
  border-color: #2db677 !important;
  border-radius: 30px 30px 30px 30px;
}

.responsive-col {
  display: flex;
  flex-wrap: wrap;
}

.auth-layout {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background-image: linear-gradient(to top, #074e74, #10476c, #154064, #183a5b, #193353, #183050, #162d4c, #152a49, #11294a, #0c294b, #06284b, #00284c);
}

.main-content {
  flex: 1 1;
}

@media (max-width: 767px) {
  .widget-direction {
    display: flex;
    flex-direction: column;
  }
  .widget-direction > div:first-child {
    order: 2;
  }
  .widget-direction > div:last-child {
    order: 1;
  }
}
@media (min-width: 768px) and (max-width: 991px) {
  .widget-direction {
    display: flex;
    flex-direction: row-reverse;
  }
}
@media (min-width: 992px) and (max-width: 1326px) {
  .widget-direction .btn-primary-dashboard {
    width: 170px;
    min-width: 170px;
    max-width: 170px;
  }
}
.video-fill {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.responsive-video {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

@media (min-width: 992px) and (max-width: 1884px) {
  .custom-row {
    flex-direction: column !important;
    gap: 8px;
  }
  .custom-video-col {
    flex: 0 0 100%;
    max-width: 100%;
  }
}
@media (max-width: 1884px) {
  .widget-direction img {
    width: 29%;
    height: auto;
  }
}
@media (min-width: 1885px) {
  .widget-direction img {
    width: 100%;
    height: auto;
  }
}
.price-container {
  position: relative;
  height: 40px;
}

.price-wrapper {
  position: absolute;
  top: 0;
  left: 0;
  transition: opacity 0.3s ease-in-out;
}

.fade-out {
  opacity: 0;
}

.fade-in {
  opacity: 1;
}

.widget-title {
  height: 50px;
  display: flex;
  font-size: 1rem;
  align-items: center;
  justify-content: flex-start;
  padding-top: 5px;
  padding-right: 0px;
  margin-right: -0.5rem;
}

.widget-text {
  height: 90px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: flex;
  justify-content: flex-start;
}

.widget-img {
  width: 70%;
  height: 70%;
}

@media screen and (max-width: 1566px) and (min-width: 1357px) {
  .widget-title {
    height: 40px;
    padding-top: 12px;
  }
  .widget-text {
    height: 120px;
  }
}
@media screen and (max-width: 1356px) and (min-width: 1228px) {
  .widget-title {
    height: 45px;
    padding-top: 10px;
  }
  .widget-text {
    height: 139px;
  }
}
@media (max-width: 1227px) {
  .widget-title {
    height: 45px;
    padding-top: 10px;
  }
  .widget-text {
    height: auto;
  }
  .widget-img {
    width: 50%;
    height: 50%;
  }
}
@media (max-width: 1228px) {
  .flex-below-1228 {
    flex-direction: column !important;
  }
}
.wdiget-row {
  margin-bottom: 0px;
}

@media screen and (max-width: 1227px) and (min-width: 1161px) {
  .wdiget-row {
    margin-bottom: -4rem;
  }
}
@media screen and (max-width: 1160px) and (min-width: 1000px) {
  .wdiget-row {
    margin-bottom: -2rem;
  }
}
@media screen and (max-width: 999px) and (min-width: 992px) {
  .wdiget-row {
    margin-bottom: -1rem;
  }
}
.widget-div-img-parent {
  margin-bottom: 3rem;
}

@media screen and (max-width: 999px) and (min-width: 806px) {
  .widget-div-img-parent {
    margin-bottom: -6.5rem;
  }
}
@media screen and (max-width: 805px) and (min-width: 768px) {
  .widget-div-img-parent {
    margin-bottom: -4.5rem;
  }
}
@media screen and (max-width: 767px) and (min-width: 565px) {
  .widget-div-img-parent {
    margin-bottom: -7.5rem;
  }
}
@media screen and (max-width: 564px) and (min-width: 300px) {
  .widget-div-img-parent {
    margin-bottom: -4.5rem;
  }
}
.video-container {
  max-width: 80%;
  width: 100%;
}

.responsive-video {
  width: 100%;
  height: auto;
  display: block;
  border-radius: 5px;
}

.sign-up-basic-card-body {
  padding-left: 2rem;
  padding-right: 2rem;
  display: flex;
  flex-direction: column;
}

.sign-in-sub-heading {
  margin-left: -3rem;
  margin-right: -8rem;
}

.line-sign-in {
  flex: 0 0 auto;
  width: 41.66667%;
}

.span-sign-in {
  flex: 0 0 auto;
  width: 16.66667%;
}

@media (max-width: 1200px) and (min-width: 992px) {
  .sign-in-card-body {
    padding-left: 4rem;
    padding-right: 4rem;
  }
  .sign-in-sub-heading {
    margin-left: -2rem;
    margin-right: -3rem;
  }
  .line-sign-in {
    flex: 0 0 auto;
    width: 35.66667%;
  }
  .span-sign-in {
    flex: 0 0 auto;
    width: 24.66667%;
  }
}
@media (max-width: 992px) and (min-width: 767px) {
  .sign-in-card-body {
    padding-left: 2rem;
    padding-right: 2rem;
  }
  .sign-in-sub-heading {
    margin-left: 1rem;
    margin-right: 1rem;
  }
}
@media (max-width: 766px) and (min-width: 529px) {
  .sign-in-sub-heading {
    margin-left: 1rem;
    margin-right: 1rem;
  }
}
@media (max-width: 421px) {
  .line-sign-in {
    flex: 0 0 auto;
    width: 40%;
  }
  .span-sign-in {
    flex: 0 0 auto;
    width: 20%;
  }
  .btn-microsoft {
    padding: 0px;
  }
}
.label {
  color: black;
}

.input-field {
  max-height: 40px !important;
}

.input-field.override-border {
  border: 1px solid red !important;
}

.account-setup-progress {
  background: #d1eaec;
  height: 12.272px !important;
  margin-top: 2rem !important;
  margin-left: 2rem !important;
  margin-right: 2rem !important;
}

.account-setup-progress-bar {
  background-color: #3bb077;
}

.account-setup-custom-button {
  max-height: 40px;
  display: inline-flex;
  align-items: center;
  border: 1px solid #b2c9d3;
  border-radius: 25px;
  cursor: pointer;
  transition: all 0.3s ease;
  color: #525f7f;
  background-color: #ffffff;
}

.account-setup-custom-button.active {
  border: 1.8px solid #3bb077 !important;
  background-color: #ffffff !important;
}

.account-setup-custom-button:hover {
  border: 1px solid #3bb077;
}

.button-flex-container {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.button-row {
  display: flex;
  justify-content: flex-start;
  gap: 4px;
}

.weight-700 {
  font-weight: 700;
}

.form-control {
  color: #000000 !important;
}

.badge.static {
  width: 72px;
  color: #2643e9;
  background-color: rgba(203, 210, 246, 0.5) !important;
}

.badge.interactive {
  width: 72px;
  color: #1aae6f;
  background-color: rgba(147, 231, 195, 0.5) !important;
}

.badge.private {
  width: 72px;
  color: #03acca;
  background-color: rgba(136, 230, 247, 0.5) !important;
}

.badge.public {
  width: 72px;
  color: #f80031;
  background-color: rgba(251, 175, 190, 0.5) !important;
}

.color-modal {
  color: #005883;
  opacity: 0.8 !important;
}

.close-button {
  position: absolute;
  top: 17px;
  right: 24px;
  font-size: 1.5rem;
  line-height: 1;
  border: none;
  background: none;
  padding: 0;
  cursor: pointer;
  appearance: none;
  -webkit-appearance: none;
}`, "",{"version":3,"sources":["webpack://./src/customCss/custom.scss"],"names":[],"mappings":"AAAA;EACE,cAAA;EACA,oCAAA;EACA,gCAAA;EACA,kCAAA;AACF;;AAEA;EACE,cAAA;EACA,oCAAA;EACA,gCAAA;EACA,kCAAA;AACF;;AAEA;EACE,YAAA;EACA,mBAAA;EACA,uBAAA;AACF;;AACA;EACE,YAAA;EACA,uBAAA;AAEF;;AAAA;EACE,YAAA;EACA,mBAAA;EACA,uBAAA;AAGF;;AADA;EACE,cAAA;EACA,oCAAA;EACA,gCAAA;EACA,kCAAA;AAIF;;AAFA;EACE,cAAA;AAKF;;AAHA;EACE,uBAAA;EACA,mBAAA;AAMF;;AAJA;EACE,uBAAA;EACA,mBAAA;AAOF;;AAJA;;EAEE,cAAA;EACA,mBAAA;AAOF;;AAJA;EACE,gDAAA;EACA,gBAAA;EACA,cAAA;EACA,yBAAA;EACA,yBAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,uBAAA;EACA,mBAAA,EAAA,6BAAA;EACA,YAAA;EACA,gBAAA;EACA,gBAAA;EACA,WAAA;AAOF;;AAAA;EACE,sEAAA;AAGF;;AAAA;EACE,qJAAA;AAGF;;AAcA;EACE,yCAAA;AAXF;;AAcA;EACE,yBAAA;EACA,cAAA;AAXF;;AAcA;EACE,aAAA;EACA,sBAAA;EACA,aAAA;AAXF;;AAcA;EACE,UAAA;EACA,0BAAA;AAXF;;AAcA;EACE,iBAAA;AAXF;;AAcA;EACE;IACE,UAAA;IACA,0BAAA;EAXF;AACF;AAcA;EACE;IACE,WAAA;IACA,0BAAA;EAZF;AACF;AAeA;EACE;IACE,UAAA;IACA,0BAAA;EAbF;AACF;AAgBA;EACE,aAAA;EACA,+BAAA;AAdF;;AAiBA;EACE,8BAAA;EACA,2BAAA;EACA,kCAAA;EACA,YAAA;EACA,4BAAA;EACA,6BAAA;EACA,yBAAA;AAdF;;AAiBA;EACE,qBAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,iBAAA;AAdF;;AAiBA;EACE,UAAA;EACA,iBAAA;AAdF;;AAiBA;EACE,YAAA;EACA,WAAA;AAdF;;AAiBA;EACE;IACE,kBAAA;EAdF;EAgBA;IACE,iBAAA;EAdF;EAgBA;IACE,6BAAA;EAdF;EAiBA;IACE,UAAA;IACA,iBAAA;EAfF;EAkBA;IACE,YAAA;IACA,WAAA;EAhBF;AACF;AAmBA;EACE,gBAAA;EACA,eAAA;EACA,gBAAA;AAjBF;;AAoBA;EACE,YAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;AAjBF;;AAoBA;EACE,aAAA;EACA,8BAAA;AAjBF;;AAoBA;EACE,SAAA;EACA,cAAA;AAjBF;;AAoBA;EACE,kBAAA;EACA,eAAA;AAjBF;;AAoBA;EACE,kBAAA;EACA,aAAA;AAjBF;;AAoBA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,4EAAA;EACA,kBAAA;AAjBF;;AAmBA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,4EAAA;EACA,mBAAA;AAhBF;;AAmBA;EACE;IACE,kBAAA,EAAA,uCAAA;EAhBF;EAkBA;IACE,mBAAA,EAAA,uCAAA;EAhBF;AACF;AAmBA;EACE;IACE,kBAAA,EAAA,uCAAA;EAjBF;EAmBA;IACE,mBAAA,EAAA,uCAAA;EAjBF;AACF;AAoBA;EACE,WAAA;EACA,kBAAA;EACA,YAAA;EACA,8BAAA;EACA,6BAAA;EACA,gBAAA;EACA,eAAA;EACA,WAAA;EACA,eAAA;EACA,sCAAA;AAlBF;;AAqBA;EACE,yBAAA,EAAA,0CAAA;AAlBF;;AAqBA;EACE,aAAA,EAAA,qBAAA;EACA,aAAA;EACA,iCAAA;AAlBF;;AAqBA;EACE,cAAA;AAlBF;;AAqBA;EACE,WAAA;EACA,mBAAA;EACA,yBAAA;EACA,qBAAA;EACA,YAAA;EACA,wBAAA;EACA,gCAAA;EACA,iBAAA;EACA,+BAAA;AAlBF;;AAqBA;EACE,0BAAA;EACA,kCAAA;AAlBF;;AAqBA;EACE,aAAA;EACA,eAAA;EACA,SAAA;EACA,2BAAA;AAlBF;;AAqBA;EACE,yBAAA;EACA,oBAAA;EACA,iBAAA;AAlBF;;AAqBA;EACE,mBAAA;EACA,eAAA;EACA,YAAA;AAlBF;;AAoBA;EACE,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,iBAAA;EACA,gBAAA;EACA,iBAAA;AAjBF;;AAmBA;EACE,qBAAA;EACA,oBAAA;EACA,kBAAA;EACA,cAAA;AAhBF;;AAmBA;EACE,cAAA;EACA,eAAA;EACA,yBAAA;AAhBF;;AAkBA;EACE,oCAAA;AAfF;;AAkBA;EACE,2CAAA;AAfF;;AAkBA;EACE,WAAA;EACA,sBAAA;EACA,gBAAA;EACA,mBAAA;EACA,yBAAA;EACA,qBAAA;EACA,gBAAA;EACA,aAAA;AAfF;;AAkBA;EACE,yBAAA;AAfF;;AAkBA;;EAEE,wBAAA;EACA,SAAA;AAfF;;AAkBA;EACE,0BAAA;AAfF;;AAkBA;EACE,gBAAA;AAfF;;AAkBA;EACE,eAAA;EACA,YAAA;EACA,WAAA;EACA,aAAA;EACA,uBAAA;EACA,iBAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EAEA,2CAAA;AAhBF;;AAmBA;EACE,yBAAA;AAhBF;;AAmBA;EACE,yBAAA;AAhBF;;AAmBA;EACE,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,sBAAA;AAhBF;;AAmBA;EACE;IACE,YAAA;EAhBF;AACF;AAmBA;EACE,yBAAA;EACA,2CAAA;EACA,eAAA;AAjBF;;AAoBA;EACE,yBAAA;EACA,2CAAA;EACA,eAAA;AAjBF;;AAoBA;EACE,gCAAA;AAjBF;;AAoBA;EACE,+BAAA;AAjBF;;AAoBA;EACE;IACE,UAAA;EAjBF;EAmBA;IACE,UAAA;IACA,sBAAA;EAjBF;AACF;AAoBA;EACE;IACE,UAAA;IACA,sBAAA;EAlBF;EAoBA;IACE,UAAA;IACA,mBAAA;EAlBF;AACF;AAqBA;EACE,iBAAA;EACA,iBAAA;AAnBF;;AAsBA;EACE;IACE,iBAAA;IACA,iBAAA;EAnBF;AACF;AAsBA;EACE;IACE,iBAAA;IACA,iBAAA;EApBF;AACF;AAuBA;EACE;IACE,iBAAA;IACA,iBAAA;EArBF;AACF;AAwBA;EACE;IACE,iBAAA;IACA,iBAAA;EAtBF;AACF;AAyBA;EACE;IACE,iBAAA;IACA,iBAAA;EAvBF;AACF;AA0BA;EACE;IACE,iBAAA;IACA,iBAAA;EAxBF;AACF;AA2BA;EACE;IACE,iBAAA;IACA,iBAAA;EAzBF;AACF;AA4BA;EACE;IACE,iBAAA;IACA,iBAAA;EA1BF;AACF;AA6BA;EACE;IACE,iBAAA;IACA,iBAAA;EA3BF;AACF;AA6BA;EACE;IACE,iBAAA;IACA,iBAAA;EA3BF;AACF;AA8BA;EACE;IACE,iBAAA;IACA,iBAAA;EA5BF;AACF;AA+BA;EACE,mBAAA;EACA,mBAAA;AA7BF;;AAgCA;EACE,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,YAAA;AA7BF;;AAgCA;EACE,YAAA;EACA,YAAA;EACA,6BAAA;AA7BF;;AA+BA;EACE,kBAAA;EACA,gBAAA;AA5BF;;AA+BA;EACE,eAAA;AA5BF;;AA+BA;EACE,YAAA;EACA,gBAAA;EACA,eAAA;AA5BF;;AA+BA;EACE,YAAA;EACA,WAAA;EACA,kBAAA;EACA,gBAAA;AA5BF;;AA+BA;EACE;IACE,kBAAA;IACA,iBAAA;EA5BF;AACF;AA8BA;EACE,YAAA;EACA,WAAA;EAEA,kBAAA;AA7BF;;AAgCA;EACE,eAAA;AA7BF;;AAgCA;EACE,YAAA;EACA,gBAAA;AA7BF;;AAgCA;EACE,YAAA;EACA,gBAAA;AA7BF;;AAgCA;EACE;IACE,YAAA;IACA,gBAAA;EA7BF;AACF;AA+BA;EACE;IACE,aAAA;IACA,iBAAA;EA7BF;AACF;AAgCA;EACE;IACE,YAAA;IACA,gBAAA;EA9BF;AACF;AAiCA;EACE;IACE,YAAA;IACA,gBAAA;EA/BF;AACF;AAkCA;EACE;IACE,eAAA;EAhCF;EAkCA;IAGE,eAAA;EAlCF;AACF;AAqCA;EACE;IACE,eAAA;EAnCF;EAqCA;IAGE,eAAA;EArCF;AACF;AAwCA;EACE;IACE,eAAA;EAtCF;EAwCA;IAGE,eAAA;EAxCF;AACF;AA2CA;EACE;IACE,eAAA;EAzCF;EA4CA;IAGE,eAAA;EA5CF;AACF;AA+CA;EACE;IACE,eAAA;EA7CF;EAgDA;IAGE,eAAA;EAhDF;AACF;AAmDA;EACE;IACE,eAAA;EAjDF;EAoDA;IAGE,eAAA;EApDF;AACF;AAuDA;EACE,aAAA;EACA,YAAA;AArDF;;AAuDA;EACE,kBAAA;AApDF;;AAuDA;EACE,yBAAA;EACA,aAAA;EACA,kBAAA;EACA,WAAA;EACA,mBAAA;AApDF;;AAuDA;EACE,cAAA,EAAA,+CAAA;EACA,iBAAA,EAAA,gCAAA;AApDF;;AAuDA;EACE,YAAA,EAAA,sEAAA;AApDF;;AAuDA;EACE;IACE,WAAA;EApDF;AACF;AAuDA;EACE,cAAA;EACA,6BAAA;EACA,gCAAA;EACA,kCAAA;AArDF;;AAwDA;EACE,cAAA;EACA,6BAAA;EACA,gCAAA;EACA,kCAAA;AArDF;;AAuDA;EACE,aAAA;EACA,eAAA;AApDF;;AAuDA;EACE,iBAAA;EACA,aAAA;EACA,sBAAA;EACA,qJAAA;AApDF;;AAqEA;EACE,SAAA;AAlEF;;AAqEA;EACE;IACE,aAAA;IACA,sBAAA;EAlEF;EAoEA;IACE,QAAA;EAlEF;EAoEA;IACE,QAAA;EAlEF;AACF;AAqEA;EACE;IACE,aAAA;IACA,2BAAA;EAnEF;AACF;AAsEA;EACE;IACE,YAAA;IACA,gBAAA;IACA,gBAAA;EApEF;AACF;AAuEA;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AArEF;;AAwEA;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;AArEF;;AAwEA;EACE;IACE,iCAAA;IACA,QAAA;EArEF;EAuEA;IACE,cAAA;IACA,eAAA;EArEF;AACF;AAuEA;EACE;IACE,UAAA;IACA,YAAA;EArEF;AACF;AAwEA;EACE;IACE,WAAA;IACA,YAAA;EAtEF;AACF;AAyEA;EACE,kBAAA;EACA,YAAA;AAvEF;;AA0EA;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,oCAAA;AAvEF;;AA0EA;EACE,UAAA;AAvEF;;AA0EA;EACE,UAAA;AAvEF;;AA0EA;EACE,YAAA;EACA,aAAA;EACA,eAAA;EACA,mBAAA;EACA,2BAAA;EACA,gBAAA;EACA,kBAAA;EAEA,qBAAA;AAxEF;;AA2EA;EACE,YAAA;EACA,gBAAA;EACA,uBAAA;EACA,aAAA;EACA,2BAAA;AAxEF;;AA2EA;EACE,UAAA;EACA,WAAA;AAxEF;;AA0EA;EACE;IACE,YAAA;IACA,iBAAA;EAvEF;EA0EA;IACE,aAAA;EAxEF;AACF;AA2EA;EACE;IACE,YAAA;IACA,iBAAA;EAzEF;EA4EA;IACE,aAAA;EA1EF;AACF;AA6EA;EACE;IACE,YAAA;IACA,iBAAA;EA3EF;EA8EA;IACE,YAAA;EA5EF;EA8EA;IACE,UAAA;IACA,WAAA;EA5EF;AACF;AA+EA;EACE;IACE,iCAAA;EA7EF;AACF;AAgFA;EACE,kBAAA;AA9EF;;AAiFA;EACE;IACE,oBAAA;EA9EF;AACF;AAiFA;EACE;IACE,oBAAA;EA/EF;AACF;AAkFA;EACE;IACE,oBAAA;EAhFF;AACF;AAmFA;EACE,mBAAA;AAjFF;;AAoFA;EACE;IACE,sBAAA;EAjFF;AACF;AAoFA;EACE;IACE,sBAAA;EAlFF;AACF;AAqFA;EACE;IACE,sBAAA;EAnFF;AACF;AAqFA;EACE;IACE,sBAAA;EAnFF;AACF;AAsFA;EACE,cAAA;EACA,WAAA;AApFF;;AAuFA;EACE,WAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;AApFF;;AAuFA;EACE,kBAAA;EACA,mBAAA;EACA,aAAA;EACA,sBAAA;AApFF;;AAuFA;EACE,kBAAA;EACA,mBAAA;AApFF;;AAuFA;EACE,cAAA;EACA,gBAAA;AApFF;;AAsFA;EACE,cAAA;EACA,gBAAA;AAnFF;;AAsFA;EACE;IACE,kBAAA;IACA,mBAAA;EAnFF;EAsFA;IACE,kBAAA;IACA,mBAAA;EApFF;EAuFA;IACE,cAAA;IACA,gBAAA;EArFF;EAuFA;IACE,cAAA;IACA,gBAAA;EArFF;AACF;AAwFA;EACE;IACE,kBAAA;IACA,mBAAA;EAtFF;EAwFA;IACE,iBAAA;IACA,kBAAA;EAtFF;AACF;AAyFA;EACE;IACE,iBAAA;IACA,kBAAA;EAvFF;AACF;AA0FA;EACE;IACE,cAAA;IACA,UAAA;EAxFF;EA0FA;IACE,cAAA;IACA,UAAA;EAxFF;EA0FA;IACE,YAAA;EAxFF;AACF;AA2FA;EACE,YAAA;AAzFF;;AA4FA;EACE,2BAAA;AAzFF;;AA2FA;EACE,gCAAA;AAxFF;;AA2FA;EACE,mBAAA;EACA,2BAAA;EACA,2BAAA;EACA,4BAAA;EACA,6BAAA;AAxFF;;AA0FA;EACE,yBAAA;AAvFF;;AA0FA;EACE,gBAAA;EACA,oBAAA;EACA,mBAAA;EACA,yBAAA;EACA,mBAAA;EACA,eAAA;EACA,yBAAA;EACA,cAAA;EACA,yBAAA;AAvFF;;AAyFA;EACE,sCAAA;EACA,oCAAA;AAtFF;;AAwFA;EACE,yBAAA;AArFF;;AAuFA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AApFF;;AAsFA;EACE,aAAA;EACA,2BAAA;EACA,QAAA;AAnFF;;AAsFA;EACE,gBAAA;AAnFF;;AAsFA;EACE,yBAAA;AAnFF;;AAsFA;EACE,WAAA;EACA,cAAA;EACA,qDAAA;AAnFF;;AAqFA;EACE,WAAA;EACA,cAAA;EACA,qDAAA;AAlFF;;AAoFA;EACE,WAAA;EACA,cAAA;EACA,qDAAA;AAjFF;;AAmFA;EACE,WAAA;EACA,cAAA;EACA,qDAAA;AAhFF;;AAmFA;EACE,cAAA;EACA,uBAAA;AAhFF;;AAmFA;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,iBAAA;EACA,cAAA;EACA,YAAA;EACA,gBAAA;EACA,UAAA;EACA,eAAA;EACA,gBAAA;EACA,wBAAA;AAhFF","sourcesContent":[".btn-primary {\n  color: #ffffff;\n  background-color: #2db577 !important;\n  border-color: #2db577 !important;\n  border-radius: 30px 30px 30px 30px;\n}\n\n.btn-danger {\n  color: #ffffff;\n  background-color: #dc4545 !important;\n  border-color: #dc4545 !important;\n  border-radius: 30px 30px 30px 30px;\n}\n\n.btn-outline {\n  color: black;\n  border-radius: 36px;\n  border: 1px solid black;\n}\n.btn-square {\n  color: black;\n  border: 1px solid black;\n}\n.btn-outline:hover {\n  color: black;\n  border-radius: 36px;\n  border: 1px solid black;\n}\n.btn-errorpage {\n  color: #ffffff;\n  background-color: #0f3a5d !important;\n  border-color: #0f3a5d !important;\n  border-radius: 30px 30px 30px 30px;\n}\n.btn-errorpage:hover {\n  color: #ffffff;\n}\n.btn-primary:disabled {\n  opacity: 0.4 !important;\n  cursor: not-allowed;\n}\n.btn-danger:disabled {\n  opacity: 0.4 !important;\n  cursor: not-allowed;\n}\n\n.btn-primary:disabled,\n.btn-primary:hover {\n  color: #ffffff;\n  cursor: not-allowed;\n}\n\n.btn-microsoft {\n  font-family: 'Segoe UI', 'Open Sans', sans-serif;\n  font-weight: 600;\n  color: #5e5e5e;\n  background-color: #ffffff;\n  border: 1px solid #8c8c8c;\n  margin-right: 0px;\n  padding-bottom: 1px;\n  padding-top: 1px;\n  text-align: center;\n  justify-content: center;\n  /* display: flex; */ /* removed the display:flex */\n  height: 41px;\n  border-radius: 0;\n  box-shadow: none;\n  width: 100%;\n}\n// .btn-microsoft:hover {\n//   color: black;\n//   border: 1px solid black;\n// }\n\n.bg-gradient-info {\n  background: linear-gradient(87deg, #005883 0, #33dae2 100%) !important;\n}\n\n.bg-gradient-auth {\n  background-image: linear-gradient(\n    to top,\n    #074e74,\n    #10476c,\n    #154064,\n    #183a5b,\n    #193353,\n    #183050,\n    #162d4c,\n    #152a49,\n    #11294a,\n    #0c294b,\n    #06284b,\n    #00284c\n  );\n}\n\n.navbar-vertical .navbar-nav .nav-link.active:before {\n  border-left: 4px solid #43ffc5 !important;\n}\n\n.custom-warning {\n  background-color: #ffc107;\n  color: #000000;\n}\n\n.full-screen-container {\n  display: flex;\n  flex-direction: column;\n  height: 100vh;\n}\n\n.custom-container {\n  width: 90%;\n  max-width: none !important;\n}\n\n.static-flow-viewer {\n  margin-right: 23%;\n}\n\n@media (min-width: 1536px) {\n  .custom-container {\n    width: 80%;\n    max-width: none !important;\n  }\n}\n\n@media (min-width: 512px) and (max-width: 1535px) {\n  .custom-container {\n    width: 100%;\n    max-width: none !important;\n  }\n}\n\n@media (max-width: 512px) {\n  .custom-container {\n    width: 96%;\n    max-width: none !important;\n  }\n}\n\n.code_llama {\n  padding: 1rem;\n  font-family: inherit !important;\n}\n\ntextarea {\n  border-radius: 15px !important;\n  font-size: large !important;\n  font-family: Open Sans, sans-serif;\n  resize: none;\n  padding-top: 1rem !important;\n  padding-left: 29px !important;\n  color: #525f7f !important;\n}\n\n.info {\n  background: gainsboro;\n  padding: 4px 10px;\n  border-radius: 15px;\n  position: absolute;\n  top: 1.5rem;\n  margin-left: 1rem;\n}\n\n.chat-navbar {\n  width: 82%;\n  margin-left: 76px;\n}\n\n.less-icon {\n  height: 19px;\n  width: 14px;\n}\n\n@media (max-width: 768px) {\n  .response-box {\n    position: relative;\n  }\n  .static-flow-viewer {\n    margin-right: 0px;\n  }\n  .code_llama {\n    padding-left: 80px !important;\n  }\n\n  .chat-navbar {\n    width: 97%;\n    margin-left: 43px;\n  }\n\n  .less-icon {\n    height: 29px;\n    width: 15px;\n  }\n}\n\n.carousel {\n  margin-top: 1rem;\n  max-height: 70%;\n  overflow: hidden;\n}\n\n.carousel img {\n  height: 100%;\n  width: 100%;\n  max-width: 100%;\n  max-height: 100%;\n}\n\n.carousel-group {\n  display: flex;\n  justify-content: space-between;\n}\n\n.carousel-image-wrapper {\n  flex: 1;\n  padding: 0 5px;\n}\n\n.carousel-outer {\n  position: relative;\n  padding: 0 50px;\n}\n\n.carousel-dropdown {\n  position: relative;\n  padding: 47px;\n}\n\n.carousel-control-prev-icon {\n  width: 50px;\n  height: 33px;\n  color: transparent;\n  filter: invert(35%) sepia(0%) saturate(1000%) hue-rotate(-180deg) !important;\n  margin-left: -45px;\n}\n.carousel-control-next-icon {\n  width: 50px;\n  height: 33px;\n  color: transparent;\n  filter: invert(35%) sepia(0%) saturate(1000%) hue-rotate(-180deg) !important;\n  margin-right: -45px;\n}\n\n@media (min-width: 375px) and (max-width: 1260px) {\n  .carousel-control-prev-icon {\n    margin-left: -15px; /* Updated margin for smaller screens */\n  }\n  .carousel-control-next-icon {\n    margin-right: -15px; /* Updated margin for smaller screens */\n  }\n}\n\n@media (min-width: 2075px) {\n  .carousel-control-prev-icon {\n    margin-left: -80px; /* Updated margin for smaller screens */\n  }\n  .carousel-control-next-icon {\n    margin-right: -80px; /* Updated margin for smaller screens */\n  }\n}\n\n.questionBar {\n  width: 100%;\n  padding: 15px 14px;\n  border: none;\n  border-top: 3px dotted #cad1d7;\n  background-color: transparent;\n  text-align: left;\n  font-size: 16px;\n  color: #333;\n  cursor: pointer;\n  transition: background-color 0.3s ease;\n}\n\n.questionBar:hover {\n  background-color: #e0e0e0; /* Slightly darker on hover for feedback */\n}\n\n.answerContent {\n  display: none; /* Initially hidden */\n  padding: 15px;\n  border-bottom: 1px dotted #cad1d7;\n}\n\n.open .answerContent {\n  display: block;\n}\n\n.questionBar::after {\n  content: '';\n  border: solid black;\n  border-width: 0 1px 1px 0;\n  display: inline-block;\n  padding: 5px;\n  transform: rotate(45deg);\n  -webkit-transform: rotate(45deg);\n  margin-left: 15px;\n  transition: transform 0.3s ease;\n}\n\n.open .questionBar::after {\n  transform: rotate(-135deg);\n  -webkit-transform: rotate(-135deg);\n}\n\n.button-container {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 1rem;\n  justify-content: flex-start;\n}\n\n.lighter-text {\n  color: rgb(181, 174, 176);\n  font-weight: lighter;\n  font-size: larger;\n}\n\n.chatbot-title {\n  font-weight: bolder;\n  font-size: 30px;\n  color: black;\n}\n.response-box {\n  border-radius: 20px;\n  border: 1px solid #cad1d7;\n  background-color: #fff;\n  min-height: 125px;\n  overflow-y: auto;\n  max-height: 800px;\n}\n.pre-wrap {\n  white-space: pre-wrap;\n  font-family: inherit;\n  font-size: inherit;\n  color: inherit;\n}\n\n.share-flow-modal .nav-tabs .nav-item .nav-link:hover {\n  color: inherit;\n  cursor: pointer;\n  border-color: transparent;\n}\n.share-flow-modal .nav-tabs .nav-item .nav-link {\n  border-bottom: 2px solid transparent;\n}\n\n.active-tab {\n  border-bottom: 2px solid #15a8b8 !important;\n}\n\n.flow-embed-box {\n  border: 1px;\n  background-color: #fff;\n  min-height: 50px;\n  white-space: normal;\n  overflow-wrap: break-word;\n  word-wrap: break-word;\n  overflow: hidden;\n  padding: 10px;\n}\n\n.flow-embed-box.flow-embed-box-background-yellow {\n  background-color: #fff3cd;\n}\n\ninput[type='number']::-webkit-inner-spin-button,\ninput[type='number']::-webkit-outer-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\ninput[type='number'] {\n  -moz-appearance: textfield;\n}\n\n.flow-viewer-navbar .navbar {\n  padding: 0 0 8px;\n}\n\n.floating-button {\n  position: fixed;\n  bottom: 20px;\n  right: 47px;\n  z-index: 1000;\n  background-color: white;\n  padding: 5px 10px;\n  color: black;\n  border: none;\n  border-radius: 5px;\n  cursor: pointer;\n\n  box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.2);\n}\n\n.progress-bar {\n  background-color: #00284c;\n}\n\n.page-item.active .page-link {\n  background-color: #00284c;\n}\n\n.custom-button-chatbot {\n  border: 1px solid black;\n  border-radius: 30px;\n  width: 196px;\n  box-sizing: border-box;\n}\n\n@-moz-document url-prefix() {\n  .custom-button-chatbot {\n    width: 220px;\n  }\n}\n\n.selected-card-class {\n  border: 2px solid #007bff;\n  box-shadow: 0 0 10px rgba(0, 123, 255, 0.5);\n  cursor: pointer;\n}\n\n.hover-card-class {\n  border: 2px solid #17a2b8;\n  box-shadow: 0 0 8px rgba(23, 162, 184, 0.5);\n  cursor: pointer;\n}\n\n.price-fade-out {\n  animation: fadeOut 0.3s forwards;\n}\n\n.price-fade-in {\n  animation: fadeIn 0.3s forwards;\n}\n\n@keyframes fadeOut {\n  from {\n    opacity: 1;\n  }\n  to {\n    opacity: 0;\n    transform: scale(0.95);\n  }\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: scale(1.05);\n  }\n  to {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n\n.plan-body-height {\n  max-height: 33rem;\n  min-height: 33rem;\n}\n\n@media (max-width: 1317px) and (min-width: 1220px) {\n  .plan-body-height {\n    max-height: 38rem;\n    min-height: 38rem;\n  }\n}\n\n@media (max-width: 1219px) and (min-width: 1120px) {\n  .plan-body-height {\n    max-height: 41rem;\n    min-height: 41rem;\n  }\n}\n\n@media (max-width: 1119px) and (min-width: 1020px) {\n  .plan-body-height {\n    max-height: 44rem;\n    min-height: 44rem;\n  }\n}\n\n@media (max-width: 1019px) and (min-width: 992px) {\n  .plan-body-height {\n    max-height: 47rem;\n    min-height: 47rem;\n  }\n}\n\n@media (max-width: 991px) and (min-width: 820px) {\n  .plan-body-height {\n    max-height: 39rem;\n    min-height: 39rem;\n  }\n}\n\n@media (max-width: 991px) and (min-width: 942px) {\n  .plan-body-height {\n    max-height: 39rem;\n    min-height: 39rem;\n  }\n}\n\n@media (max-width: 941px) and (min-width: 892px) {\n  .plan-body-height {\n    max-height: 41rem;\n    min-height: 41rem;\n  }\n}\n\n@media (max-width: 891px) and (min-width: 842px) {\n  .plan-body-height {\n    max-height: 44rem;\n    min-height: 44rem;\n  }\n}\n\n@media (max-width: 841px) and (min-width: 820px) {\n  .plan-body-height {\n    max-height: 46rem;\n    min-height: 46rem;\n  }\n}\n@media (max-width: 819px) and (min-width: 768px) {\n  .plan-body-height {\n    max-height: 49rem;\n    min-height: 49rem;\n  }\n}\n\n@media (max-width: 767px) {\n  .plan-body-height {\n    max-height: 34rem;\n    min-height: 34rem;\n  }\n}\n\n.plan-card-header {\n  padding-right: 20px;\n  padding-bottom: 8px;\n}\n\n.professional-plan-nested-cards {\n  border: none;\n  background-color: #f4f4f4;\n  border-radius: 0px;\n  margin-top: 6px;\n  height: 79px;\n}\n\n.professional-card {\n  padding: 0px;\n  border: none;\n  background-color: transparent;\n}\n.professional-plan-nested-cards-body {\n  padding-left: 11px;\n  padding-top: 0px;\n}\n\n.plan-title {\n  font-size: 20px;\n}\n\n.plan-price {\n  height: 3rem;\n  max-height: 3rem;\n  margin-top: 3px;\n}\n\n.professional-plan-nested-cards-single-icon {\n  height: 25px;\n  width: 80px;\n  margin-top: -127px;\n  margin-left: 8px;\n}\n\n@media (min-width: 990px) {\n  .professional-plan-nested-cards-single-icon {\n    margin-top: -109px;\n    margin-left: 39px;\n  }\n}\n.professional-plan-nested-cards-teams-icon {\n  height: 31px;\n  width: 80px;\n  // margin-top: -10px;\n  margin-left: -18px;\n}\n\n.plan-button {\n  margin-top: 2px;\n}\n\n.card-nested-body {\n  height: 8rem;\n  max-height: 8rem;\n}\n\n.plan-main-text {\n  height: 6rem;\n  min-height: 6rem;\n}\n\n@media (min-width: 1127px) {\n  .plan-main-text {\n    height: 6rem;\n    min-height: 6rem;\n  }\n}\n@media (min-width: 992px) and (max-width: 1127px) {\n  .plan-main-text {\n    height: 10rem;\n    min-height: 10rem;\n  }\n}\n\n@media (min-width: 767px) and (max-width: 992px) {\n  .plan-main-text {\n    height: 8rem;\n    min-height: 8rem;\n  }\n}\n\n@media (min-width: 300px) and (max-width: 766px) {\n  .plan-main-text {\n    height: 4rem;\n    min-height: 4rem;\n  }\n}\n\n@media (max-width: 576px) {\n  .plan-title {\n    font-size: 10px;\n  }\n  .plan-price {\n    // height: 3rem;\n    // max-height: 3rem;\n    font-size: 10px;\n  }\n}\n\n@media (max-width: 767px) {\n  .plan-title {\n    font-size: 12px;\n  }\n  .plan-price {\n    // height: 3rem;\n    // max-height: 3rem;\n    font-size: 12px;\n  }\n}\n\n@media (max-width: 991px) {\n  .plan-title {\n    font-size: 15px;\n  }\n  .plan-price {\n    // height: 3rem;\n    // max-height: 3rem;\n    font-size: 15px;\n  }\n}\n\n@media (min-width: 992px) and (max-width: 1143px) {\n  .plan-title {\n    font-size: 12px;\n  }\n\n  .plan-price {\n    // height: 3rem;\n    // max-height: 3rem;\n    font-size: 31px;\n  }\n}\n\n@media (min-width: 1144px) and (max-width: 1243px) {\n  .plan-title {\n    font-size: 17px;\n  }\n\n  .plan-price {\n    // height: 3rem;\n    // max-height: 3rem;\n    font-size: 25px;\n  }\n}\n\n@media (min-width: 1244px) {\n  .plan-title {\n    font-size: 18px;\n  }\n\n  .plan-price {\n    // height: 4rem;\n    // max-height: 4rem;\n    font-size: 31px;\n  }\n}\n\n.translatin-icon {\n  height: 120px;\n  width: 120px;\n}\n.list-item-spacing {\n  margin-bottom: 3px;\n}\n\n.plan-card-details {\n  background-color: #fdfdfd;\n  padding: 10px;\n  margin-left: -18px;\n  width: 120%;\n  margin-bottom: 10px;\n}\n\n.icon-container {\n  flex-shrink: 0; /* Ensures the icon container does not shrink */\n  margin-right: 8px; /* Adjust the margin as needed */\n}\n\n.text-container {\n  flex-grow: 1; /* Allows the text container to grow and take up the remaining space */\n}\n\n@media (max-width: 767px) {\n  .plan-card-details {\n    width: 100%;\n  }\n}\n\n.btn-primary-dashboard {\n  color: #2db677;\n  background-color: transparent;\n  border-color: #2db677 !important;\n  border-radius: 30px 30px 30px 30px;\n}\n\n.btn-primary-dashboard:hover {\n  color: #2db677;\n  background-color: transparent;\n  border-color: #2db677 !important;\n  border-radius: 30px 30px 30px 30px;\n}\n.responsive-col {\n  display: flex;\n  flex-wrap: wrap;\n}\n\n.auth-layout {\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  background-image: linear-gradient(\n    to top,\n    #074e74,\n    #10476c,\n    #154064,\n    #183a5b,\n    #193353,\n    #183050,\n    #162d4c,\n    #152a49,\n    #11294a,\n    #0c294b,\n    #06284b,\n    #00284c\n  );\n}\n\n.main-content {\n  flex: 1;\n}\n\n@media (max-width: 767px) {\n  .widget-direction {\n    display: flex;\n    flex-direction: column;\n  }\n  .widget-direction > div:first-child {\n    order: 2;\n  }\n  .widget-direction > div:last-child {\n    order: 1;\n  }\n}\n\n@media (min-width: 768px) and (max-width: 991px) {\n  .widget-direction {\n    display: flex;\n    flex-direction: row-reverse;\n  }\n}\n\n@media (min-width: 992px) and (max-width: 1326px) {\n  .widget-direction .btn-primary-dashboard {\n    width: 170px;\n    min-width: 170px;\n    max-width: 170px;\n  }\n}\n\n.video-fill {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.responsive-video {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n}\n\n@media (min-width: 992px) and (max-width: 1884px) {\n  .custom-row {\n    flex-direction: column !important;\n    gap: 8px;\n  }\n  .custom-video-col {\n    flex: 0 0 100%;\n    max-width: 100%;\n  }\n}\n@media (max-width: 1884px) {\n  .widget-direction img {\n    width: 29%;\n    height: auto;\n  }\n}\n\n@media (min-width: 1885px) {\n  .widget-direction img {\n    width: 100%;\n    height: auto;\n  }\n}\n\n.price-container {\n  position: relative;\n  height: 40px;\n}\n\n.price-wrapper {\n  position: absolute;\n  top: 0;\n  left: 0;\n  transition: opacity 0.3s ease-in-out;\n}\n\n.fade-out {\n  opacity: 0;\n}\n\n.fade-in {\n  opacity: 1;\n}\n\n.widget-title {\n  height: 50px;\n  display: flex;\n  font-size: 1rem;\n  align-items: center;\n  justify-content: flex-start;\n  padding-top: 5px;\n  padding-right: 0px;\n\n  margin-right: -0.5rem;\n}\n\n.widget-text {\n  height: 90px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  display: flex;\n  justify-content: flex-start;\n}\n\n.widget-img {\n  width: 70%;\n  height: 70%;\n}\n@media screen and (max-width: 1566px) and (min-width: 1357px) {\n  .widget-title {\n    height: 40px;\n    padding-top: 12px;\n  }\n\n  .widget-text {\n    height: 120px;\n  }\n}\n\n@media screen and (max-width: 1356px) and (min-width: 1228px) {\n  .widget-title {\n    height: 45px;\n    padding-top: 10px;\n  }\n\n  .widget-text {\n    height: 139px;\n  }\n}\n\n@media (max-width: 1227px) {\n  .widget-title {\n    height: 45px;\n    padding-top: 10px;\n  }\n\n  .widget-text {\n    height: auto;\n  }\n  .widget-img {\n    width: 50%;\n    height: 50%;\n  }\n}\n\n@media (max-width: 1228px) {\n  .flex-below-1228 {\n    flex-direction: column !important;\n  }\n}\n\n.wdiget-row {\n  margin-bottom: 0px;\n}\n\n@media screen and (max-width: 1227px) and (min-width: 1161px) {\n  .wdiget-row {\n    margin-bottom: -4rem;\n  }\n}\n\n@media screen and (max-width: 1160px) and (min-width: 1000px) {\n  .wdiget-row {\n    margin-bottom: -2rem;\n  }\n}\n\n@media screen and (max-width: 999px) and (min-width: 992px) {\n  .wdiget-row {\n    margin-bottom: -1rem;\n  }\n}\n\n.widget-div-img-parent {\n  margin-bottom: 3rem;\n}\n\n@media screen and (max-width: 999px) and (min-width: 806px) {\n  .widget-div-img-parent {\n    margin-bottom: -6.5rem;\n  }\n}\n\n@media screen and (max-width: 805px) and (min-width: 768px) {\n  .widget-div-img-parent {\n    margin-bottom: -4.5rem;\n  }\n}\n\n@media screen and (max-width: 767px) and (min-width: 565px) {\n  .widget-div-img-parent {\n    margin-bottom: -7.5rem;\n  }\n}\n@media screen and (max-width: 564px) and (min-width: 300px) {\n  .widget-div-img-parent {\n    margin-bottom: -4.5rem;\n  }\n}\n\n.video-container {\n  max-width: 80%;\n  width: 100%;\n}\n\n.responsive-video {\n  width: 100%;\n  height: auto;\n  display: block;\n  border-radius: 5px;\n}\n\n.sign-up-basic-card-body {\n  padding-left: 2rem;\n  padding-right: 2rem;\n  display: flex;\n  flex-direction: column;\n}\n\n.sign-in-sub-heading {\n  margin-left: -3rem;\n  margin-right: -8rem;\n}\n\n.line-sign-in {\n  flex: 0 0 auto;\n  width: 41.66667%;\n}\n.span-sign-in {\n  flex: 0 0 auto;\n  width: 16.66667%;\n}\n\n@media (max-width: 1200px) and (min-width: 992px) {\n  .sign-in-card-body {\n    padding-left: 4rem;\n    padding-right: 4rem;\n  }\n\n  .sign-in-sub-heading {\n    margin-left: -2rem;\n    margin-right: -3rem;\n  }\n\n  .line-sign-in {\n    flex: 0 0 auto;\n    width: 35.66667%;\n  }\n  .span-sign-in {\n    flex: 0 0 auto;\n    width: 24.66667%;\n  }\n}\n\n@media (max-width: 992px) and (min-width: 767px) {\n  .sign-in-card-body {\n    padding-left: 2rem;\n    padding-right: 2rem;\n  }\n  .sign-in-sub-heading {\n    margin-left: 1rem;\n    margin-right: 1rem;\n  }\n}\n\n@media (max-width: 766px) and (min-width: 529px) {\n  .sign-in-sub-heading {\n    margin-left: 1rem;\n    margin-right: 1rem;\n  }\n}\n\n@media (max-width: 421px) {\n  .line-sign-in {\n    flex: 0 0 auto;\n    width: 40%;\n  }\n  .span-sign-in {\n    flex: 0 0 auto;\n    width: 20%;\n  }\n  .btn-microsoft {\n    padding: 0px;\n  }\n}\n\n.label {\n  color: black;\n}\n\n.input-field {\n  max-height: 40px !important;\n}\n.input-field.override-border {\n  border: 1px solid red !important;\n}\n\n.account-setup-progress {\n  background: #d1eaec;\n  height: 12.272px !important;\n  margin-top: 2rem !important;\n  margin-left: 2rem !important;\n  margin-right: 2rem !important;\n}\n.account-setup-progress-bar {\n  background-color: #3bb077;\n}\n\n.account-setup-custom-button {\n  max-height: 40px;\n  display: inline-flex;\n  align-items: center;\n  border: 1px solid #b2c9d3;\n  border-radius: 25px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  color: #525f7f;\n  background-color: #ffffff;\n}\n.account-setup-custom-button.active {\n  border: 1.8px solid #3bb077 !important;\n  background-color: #ffffff !important;\n}\n.account-setup-custom-button:hover {\n  border: 1px solid #3bb077;\n}\n.button-flex-container {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n.button-row {\n  display: flex;\n  justify-content: flex-start;\n  gap: 4px;\n}\n\n.weight-700 {\n  font-weight: 700;\n}\n\n.form-control {\n  color: #000000 !important;\n}\n\n.badge.static {\n  width: 72px;\n  color: #2643e9;\n  background-color: rgba(203, 210, 246, 0.5) !important;\n}\n.badge.interactive {\n  width: 72px;\n  color: #1aae6f;\n  background-color: rgba(147, 231, 195, 0.5) !important;\n}\n.badge.private {\n  width: 72px;\n  color: #03acca;\n  background-color: rgba(136, 230, 247, 0.5) !important;\n}\n.badge.public {\n  width: 72px;\n  color: #f80031;\n  background-color: rgba(251, 175, 190, 0.5) !important;\n}\n\n.color-modal {\n  color: #005883;\n  opacity: 0.8 !important;\n}\n\n.close-button {\n  position: absolute;\n  top: 17px;\n  right: 24px;\n  font-size: 1.5rem;\n  line-height: 1;\n  border: none;\n  background: none;\n  padding: 0;\n  cursor: pointer;\n  appearance: none;\n  -webkit-appearance: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
